import React, { useState, useEffect, useContext } from "react";
import { Alert, Box, Grid, TextField, Typography, Button, Checkbox, FormControlLabel, Tooltip } from '@mui/material';
import MenuItem from '@mui/material/MenuItem';
import Switch from '@mui/material/Switch';
import FormControl from '@mui/material/FormControl';
import FormGroup from "@mui/material/FormGroup";
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import successIcon from '../assets/payment-success-icon.png';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import DeleteIcon from '@mui/icons-material/Delete';
import IconButton from '@mui/material/IconButton';
import { useAuth } from '../hooks/useAuth';
import { useNavigate } from 'react-router-dom';
import { useMember } from '../context/MemberProfileContext';


import PaymentComp from '../components/PaymentComp'
import { DataContext } from '../App';


const amber = '#B8860A';
const navy = '#1A3A6B';
const pageBg = '#f8f7f2';

const Section = ({ title, children }) => (
    <Box sx={{ border: '1px solid #c8d4de', borderRadius: 1.5, mb: 3, overflow: 'hidden' }}>
        <Box sx={{ bgcolor: '#e4eaf0', borderBottom: '1px solid #c8d4de', px: 3, py: 1.5 }}>
            <Typography sx={{ color: navy, fontWeight: 700, fontSize: '1rem', fontFamily: '"Roboto","Helvetica","Arial",sans-serif', textAlign: 'left' }}>
                {title}
            </Typography>
        </Box>
        <Box sx={{ p: 3 }}>
            {children}
        </Box>
    </Box>
);

export default function BalaviharRegistration() {
    
    const [tempData, setTempData] = useState({
        "membershipType": "",
        "membershipGeneralAdmissionFee": 0,
        "membershipParivarNoBalaviharFee": 0,
        "membershipParivarMemberFee": 0,
        "membershipSingleChildFee": 0,
        "membershipTwoPlusChildFee": 0,
        "membershipTypeName": "",
    });
    const [membershipData, setMembershipData] = useState({
        "balaviharYear": "",
        "status": "",
        "membershipType": {
            "name": ""
            },
        "currentMembership": {
            "notes": "First time registering"
        },
        
        "currentTransaction": {
            "quantities": "1",
            "itemPrice": "",
            "donationAmount": "0",
            "totalAmount": "",
            "payerId": "",
            "notes": "before checkout"
        },
        "registeredSessions": [
            {
                "notes": "",
                "memberEntity": {
                    "firstName": "",
                    "lastName": ""
                },
                "sessionEntity": {
                    "sessionName": ""
                },
                "gradeEntity": {
                    "grade": ""
                }
            }]
        });

        function loadMembershipData() {
            //membershipData.balaviharYear = memberships.currentMembership.transactionEntity.eventTypesEntity.eventYear;
            membershipData.balaviharYear = memberships.balaviharYear;
            membershipData.currentTransaction.quantities = noOfPeople;
            membershipData.currentTransaction.itemPrice = ticketPrice;
            membershipData.currentTransaction.donationAmount = donation;
            membershipData.currentTransaction.totalAmount = totalAmount;

              // Populate registeredSessions array from studentFields
            membershipData.registeredSessions = studentFields.map((student) => ({
                notes: "",
                memberEntity: {
                firstName: student.firstName,
                lastName: student.lastName,
                },
                sessionEntity: {
                sessionName: student.session,
                },
                gradeEntity: {
                grade: student.grade,
                },
            }));
            if (parivarMember) { //
                membershipData.membershipType.name = "Chinmaya Parivar Member";    
                };
            console.log("Membership Data after Database call :", membershipData);      
    
            };
   


    const [eventData, setEventData] = useState({
        parent: {
            memberType: "parent",
            firstName: "",
            lastName: "",
            mobileNumber: "",
            email: "",
            gender: "",
            age: 5,
            grade: "",
            tshirtSize: "",
            streetAddress: "",
            city: "",
            state: "",
            postalCode: "",
            allergies: "",
            notes: "",
            childCareReqd: "",
            volunteer: ""
        },
        spouse: {
            memberType: "spouse",
            firstName: "",
            lastName: "",
            mobileNumber: "",
            email: "",
            gender: "",
            age: 0,
            grade: "",
            streetAddress: "",
            city: "",
            state: "",
            postalCode: "",
            allergies: "",
            notes: "",
            childCareReqd: "",
            volunteer: ""
        },
        children: [{
            memberType: "child",
            firstName: "",
            lastName: "",
            fullName: "",
            grade: "",
            session: ""
        }],
        guest: [],
        transaction: {
            quantities: 1,
            itemPrice: 0,
            totalAmount: "",
            donationAmount: "",
            paymentStatus: "",
            payerId: ""
        },
        medical: {
            pcpName: "",
            pcpMobile: "",
            medicalInsurance: "",
            groupNo: "",
            idNo: "",
            medicalNotes: "",
            medicalConsentSignedBy: "",
            treatmentConsentSignedBy: ""
        },
        tshirts: [],
        eventType: 'BVRegistration',
        eventTypeId: 13,
        center: '',
        notes: '',
        sessionName: "",
        otherCenter: '',
        feeEnabled: 0,
        parivarEnabled: 0,
        success: false
    });
    //to populate registered children
    const { memberProfile, setMemberProfile } = useMember();
    
    //const [fullNames, setFullNames] = useState();
    const [fullNames, setFullNames] = useState(memberProfile.children.map((child) => child.fullName));
    const [sessions, setSessions] = useState();
    //const [grades, setGrades] = useState([]);
    const [grades, setGrades] = useState(['BV PRE-Kindergarten', 'BV Kindergarten', 'BV 1st Grade', 'BV 2nd Grade', 'BV 3rd Grade','BV 4th Grade', 'BV 5th Grade', 'BV 6th Grade', 'BV 7th Grade', 'BV 8th Grade', 'BV 9th Grade', 'BV 10th Grade', 'BV 11th Grade', 'BV 12th Grade']);
    const [gradeFlag, setGradeFlag] = useState(false);
    const [studentFields, setStudentFields] = useState([]);
    const [error, setError] = useState(null);
    const [childLimit, setChildLimit] = useState(4);
    
    const { accessToken, signOut } = useAuth();
    const [rulesAccepted, setRulesAccepted] = useState(false); // State to manage checkbox
    const API_URL = process.env.REACT_APP_API_URL;
    const navigate = useNavigate();
    const { memberships, setMemberships} = useMember();
    const [parivarMember, setParivarMember] = useState(false);
   
    
    const [ticketPrice, setTicketPrice] = useState(0);  
    const eventTypes = useContext(DataContext);
    console.log("Enter Balavihar Registration: ", accessToken);
    console.log("Enter Full Names, sessions, grades : ", fullNames, sessions, grades, memberProfile);

  useEffect(() => {

    console.log("Token exists or not :", accessToken);

    if (accessToken) {
        console.log("Token exists or not test:", accessToken);       
        memberProfileFetch(); // Load membership data
        console.log("Temp data :", tempData);
    } else {
        signOut();
        navigate('/');
    }
  }, [accessToken])         // Empty dependency array ensures this runs once on mount;

  useEffect(() => {
    console.log("inside membership changes :");

      if (memberships && memberships.membershipTypes && memberships.membershipTypes.length > 0) {
          loadMembershipFeeData(); // Load membership fee data
          setSessions(memberships.availableSessions.map((child) => child.sessionName));

       // Set childLimit based on childQuantities for specific membership types
       /* const membershipType = memberships.membershipTypes.find(type => type.name === 'Chinmaya Parivar Member' || type.name === 'Balavihar (2+ Children)');
        if (membershipType) {
            setChildLimit(membershipType.childQuantities || 0);
        }  */        
      }  
     
    if (memberships.registeredSessions && memberships.registeredSessions.length > 0) {
        setStudentFields(memberships.registeredSessions.map((session) => ({
            memberType: "child",
            firstName: session.memberEntity.firstName,
            lastName: session.memberEntity.lastName,
            fullName: session.memberEntity.fullName,
            session: session.sessionEntity.sessionName,
            grade: session.gradeEntity.grade,
            gradeFlag: true
        })));
        setNoOfPeople(memberships.registeredSessions.length);
    }
    if ((memberships.status === "ACTIVE") && (memberships.currentMembership.membershipTypesEntity.name === "Chinmaya Parivar Member")) 
        {
        setParivarMember(true);
        };
    console.log("inside loading student fields :" , studentFields);

  }, [memberships]);

 
    useEffect(() => {
        eventData.parent.firstName = memberProfile.primary.firstName;
        eventData.parent.lastName = memberProfile.primary.lastName;
        eventData.parent.email = memberProfile.primary.email;
        eventData.parent.mobileNumber = memberProfile.primary.mobileNumber.replace(/[-\s]/g, ''); // Remove hyphens and spaces    
    }, [])         // Empty dependency array ensures this runs once on mount

    //console.log("Ticket price :", ticketPrice);
    console.log("Membershipdata, Temp and student data :", membershipData, tempData, studentFields);

    const [inputFields, setInputFields] = useState(eventData.transaction);
        const [feeEnabled, setFeeEnabled] = useState(0);
    const [parivarEnabled, setParivarEnabled] = useState(0);

    const [donation, setDonation] = useState(0);
    const [totalAmount, setTotalAmount] = useState(inputFields.quantities * inputFields.itemPrice);
    const [noOfPeople, setNoOfPeople] = useState(0);
    console.log("Event data in Student handle form :", (studentFields), noOfPeople, memberships.totalAmountPaid);        
 
    const total = () => {
        inputFields.donationAmount = donation;
        inputFields.totalAmount = totalAmount;
        eventData.transaction = inputFields;
    }
    total();
    
    useEffect(() => {
        //eventData.transaction.quantities = noOfPeople;
        // When the user switches between membership types, reset the student fields
        if (tempData.membershipType === "GeneralAdmission") {
            setStudentFields([]);
            //membershipData.registeredSessions = ([]);
            setNoOfPeople(0);
        }
        if ((tempData.membershipType === "Balavihar") && (noOfPeople === 0)) {
            setTicketPrice(0); // Reset ticket price when switching between membership types
        }
        
        if (noOfPeople === 1) { 
            setTicketPrice(tempData.membershipSingleChildFee - memberships.totalAmountPaid);
            membershipData.membershipType.name = "Balavihar (Single Child)";} 
        if (noOfPeople >= 2) {
            setTicketPrice(tempData.membershipTwoPlusChildFee - memberships.totalAmountPaid);
            membershipData.membershipType.name = "Balavihar (2+ Children)";};
        if (tempData.membershipType === "GeneralAdmission" || (memberships.status === "ACTIVE" && noOfPeople === 0)) {
            setTicketPrice(tempData.membershipGeneralAdmissionFee - memberships.totalAmountPaid);
            membershipData.membershipType.name = "General Member (NO Balavihar)";}
        if (parivarEnabled || parivarMember) {
            setTicketPrice(tempData.membershipParivarMemberFee - memberships.totalAmountPaid);
            if (tempData.membershipType === "Balavihar" || memberships.status === "ACTIVE" ) {
                setTicketPrice(tempData.membershipParivarMemberFee - memberships.totalAmountPaid);
                membershipData.membershipType.name = "Chinmaya Parivar Member";
            }
            if (tempData.membershipType === "GeneralAdmission" || memberships.status === "ACTIVE" ) {
                setTicketPrice(tempData.membershipParivarNoBalaviharFee - memberships.totalAmountPaid);
                //membershipData.membershipType.name = "Chinmaya Parivar (NO Balavihar)";
                membershipData.membershipType.name = "Chinmaya Parivar Member";
            }
        }
        eventData.transaction.itemPrice = ticketPrice;
        if (feeEnabled) {
            setTotalAmount(((parseInt(ticketPrice) + parseInt(donation)) * 1.03).toFixed(2));
        } else {
            setTotalAmount((parseInt(ticketPrice) + parseInt(donation)) * 1.00);
        }

        eventData.transaction.totalAmount = totalAmount;
    }, [noOfPeople, donation, feeEnabled, parivarEnabled, tempData.membershipType, ticketPrice])

    const handleSessionChange = (e, index) => {
        console.log("Handle session change :", e.target.name, e.target.value, (studentFields));        

        let newForm = [...studentFields];
        newForm[index][e.target.name] = e.target.value;
        //newForm[index].gradeFlag = true;
        setStudentFields(newForm);
        const selectedSession = memberships.availableSessions.find((session) => session.sessionName === e.target.value);
        setGrades(selectedSession ? selectedSession.grades.map((grade) => grade.grade) : []);  
        setGradeFlag(true); // Enable grade selection        
    }

    const handleStudentChange = (e, index) => {
        //console.log("Event data in Student handle form :", (studentFields));        
        let newForm = [...studentFields];
        newForm[index][e.target.name] = e.target.value;
        const selectedChild = memberProfile.children.find((child) => child.fullName === e.target.value);
        if (selectedChild) { // Populate the child's details
            newForm[index].firstName = selectedChild.firstName;
            newForm[index].lastName = selectedChild.lastName;
        }
        setStudentFields(newForm);
        eventData.children = newForm;
    }
    // Populate the full names of the available children
    const getAvailableChildren = (index) => {
        const selectedChildren = studentFields.map((student) => student.fullName);
        return fullNames.filter((name) => !selectedChildren.includes(name) || studentFields[index].fullName === name);
    }
    const handleAddFields = () => {
        //console.log("Handle add fileds", fullNames.length, noOfPeople, childLimit, fullNames.length - 1);
        if (noOfPeople >= fullNames.length) {
            console.log("No children available to add. Please add children in the profile screen to proceed.");
            setError("No children available to add. Please add children in the profile screen to proceed or Checkout to complete the registration.");
        return;
        }
        if (noOfPeople >= childLimit) {
            setError("Children registration limit reached. Please reach out to membership support to enroll more than 4 children or Checkout to complete the registration.");
        return;
        }   

        setStudentFields([...studentFields, {
            memberType: "child", firstName: "", lastName: "", fullName: "", session: "", grade: ""
        }]);
        setNoOfPeople(noOfPeople + 1);
        //c1 setGradeFlag(false);        
    };

    const handleRemoveFields = (index) => {
        const values = [...studentFields];
        values.splice(index, 1);
        setStudentFields(values);
        eventData.children = values;
        setNoOfPeople(noOfPeople - 1);
    };

    const handleLogout = () => {
        signOut();
        navigate('/');
      };

    const memberProfileFetch = async () => {
        console.log("Token value B", accessToken);
        let response, data;
        try {    
          //const response = await fetch('https://membership.cmdfw.org/api/gquery', {
          const response = await fetch(`${API_URL}/gquery`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'x-cmdfw-jwt-token': `${accessToken}`,
            },
              body: JSON.stringify({
                  query: `
                          query {
                            memberships {
                                balaviharYear
                                balaviharPeriod
                                status
                                totalAmountPaid
                                membershipTypes {
                                    membershipTypeId
                                    name
                                    startDate
                                    endDate
                                    bvPrice
                                    childQuantities
                                }
                                availableSessions {
                                    sessionId
                                    center
                                    sessionName
                                    grades {
                                        gradeId
                                        grade
                                    }
                                }
                                registeredSessions{
                                    bvRegistrationId
                                    regStartDate
                                    regEndDate
                                    status
                                    memberEntity{
                                        firstName
                                        lastName
                                        fullName
                                    }
                                    sessionEntity {
                                        sessionId
                                        center
                                        sessionName
                                    }
                                    gradeEntity{
                                        gradeId
                                        grade
                                    }
                                }
                                currentMembership {
                                    membershipId
                                    startDate
                                    endDate
                                    status
                                    notes
                                    bvYear
                                    createdAt 
                                    createdBy 
                                    membershipTypesEntity{
                                        membershipTypeId
                                        name
                                        startDate
                                        endDate
                                    }
                                    transactionEntity {
                                        transactionId
                                        eventTypesEntity {
                                            eventTypeId
                                            name
                                            eventYear
                                        }
                                        totalAmount
                                        paymentStatus
                                        createdAt 
                                        createdBy 
                                    }
                                }
                            }
                          }
                        `,
            }),
          });
    
          const data = await response.json();
          if (response.ok) {
            setMemberships(data.data.memberships);
            console.log("Membership data after API call:", data, response);
          } else {
            if (response.status === 403) {
              const errorData = await response.json();
              handleLogout(); // Logout user
              throw new Error(errorData.message || 'OTP expired');
            } else {
              if (!response.ok) {
                const errorData = await response.json();
                throw new Error(errorData.message || 'Membership fetch failed');
              }
            }
          }
        } catch (error) {
          console.error("Error fetching Membership Profile :", error);
          signOut();
          //navigate('/');
        }
      };
    function loadMembershipFeeData() {
        console.log("Membership Profile data to load fees  :", memberships);            

        memberships.membershipTypes.forEach((membershipType) => {
            if (membershipType.name === 'Chinmaya Parivar Member') {
                setTempData((prevData) => ({ ...prevData, membershipParivarMemberFee: membershipType.bvPrice }));
            } else if (membershipType.name === 'General Member (NO Balavihar)') {
                setTempData((prevData) => ({ ...prevData, membershipGeneralAdmissionFee: membershipType.bvPrice }));
            } else if (membershipType.name === 'Balavihar (Single Child)') {
                setTempData((prevData) => ({ ...prevData, membershipSingleChildFee: membershipType.bvPrice }));
            } else if (membershipType.name === 'Balavihar (2+ Children)') {
                setTempData((prevData) => ({ ...prevData, membershipTwoPlusChildFee: membershipType.bvPrice }));
            } else if (membershipType.name === 'Chinmaya Parivar (NO Balavihar)') {
                setTempData((prevData) => ({ ...prevData, membershipParivarNoBalaviharFee: membershipType.bvPrice }));
            }
        });
        

    };
    const checkoutHandler = (e) => {
        e.preventDefault();
        setError(null);
        loadMembershipData();
        //membershipData.currentTransaction.totalAmount = 0;
        // Skip payment if total amount is zero
        if (totalAmount >0 ) {        
            membershipData.status = "pending";
        } else {
            membershipData.status = "paid";
            setSuccess(true); // Skip payment if total amount is zero
        }

        //    console.log("transaction before sent to SQS:", (inputFields));
        if (sendToServer()) {
            console.log("checkout true");
            //setCheckout(true);
        } else {
            //setCheckout(false);
            console.log("checkout false");
        }
    };
    async function sendToServer() {
        console.log("transaction before sent to Database:", membershipData);
        const maxRetries = 3; // Maximum number of retries
        let attempt = 0;

        while (attempt < maxRetries) {
            try {
            //const url = process.env.REACT_APP_SQS_URL;
            const response = await fetch(`${API_URL}/memberships`, {
                method: "POST",
                headers: {
                    'Content-Type': 'application/json',
                    "x-cmdfw-jwt-token": `${accessToken}`,
                },
                body: JSON.stringify(membershipData),
            });
            console.log('API response:', response.data);
            if (response.ok) {
                setCheckout(true);
                return true; // Success
            }
            if (response.status === 403) {
                const errorData = await response.json();
                handleLogout(); // Logout user
                throw new Error(errorData.message || 'OTP expired');
              } else {
                const errorData = await response.json();
                console.error('API Error:', errorData);
                setError(errorData.message);
                return false; // API call failed
                //throw new Error(errorData.message || 'API call failed');
            }
        } catch (error) {
            console.error(`Attempt ${attempt + 1} failed:`, error);
            attempt++;

            if (attempt >= maxRetries) {
                console.error('All retry attempts failed.');
                setCheckout(false);
                setError("Failed to send data to the server. Please try again later.");
                return false; // Return false after all retries fail
            }

            console.log(`Retrying API call... (${attempt}/${maxRetries})`);
 
        }
    }
    }

    function peopleSwitchHandler(e) {
        console.log("switch handler :", e.target.checked);

        handleAddFields();
        //setAddPeople(e.target.checked);
    };

    function feeSwitchHandler(e) {
        setFeeEnabled(e.target.checked);
        eventData.feeEnabled = e.target.checked ;
        //console.log("Event data feeSwitchHandler :", (eventData.feeEnabled));
    }
    function parivarSwitchHandler(e) {
        setParivarEnabled(e.target.checked);
        eventData.parivarEnabled = e.target.checked ;
    }

    function handleBack() {
        setCheckout(false);
    }

    function handleDonation(e) {
        setInputFields({ ...inputFields, [e.target.name]: parseInt(e.target.value) });
        if (e.target.value >= 0) {
            setDonation(parseInt(e.target.value));
        }
    };

    const handleCancel = () => {
        navigate('/EventTypesForm');
        // Add any additional save logic here, such as API calls
      };
    
 
    const [success, setSuccess] = useState(false)
    const [checkout, setCheckout] = useState(false)

    return (
        <Box sx={{ bgcolor: pageBg, minHeight: '100vh', py: 4, px: { xs: 2, md: 4 }, display: 'flex', justifyContent: 'center' }}>
            <Box sx={{ width: '100%', maxWidth: 760, bgcolor: '#fff', borderRadius: 2, boxShadow: 3, overflow: 'hidden', alignSelf: 'flex-start' }}>

                <Box sx={{ bgcolor: navy, px: { xs: 3, md: 5 }, py: 3 }}>
                    <Typography variant="h5" sx={{ color: '#fff', fontFamily: 'Georgia, serif', fontWeight: 700, letterSpacing: 0.5 }}>
                        Balavihar Registration
                    </Typography>
                    <Typography variant="body2" sx={{ color: '#c5d8ea', mt: 0.5 }}>
                        CMDFW Membership Registration
                    </Typography>
                </Box>

                <Box sx={{ px: { xs: 2, md: 3 }, py: 3 }}>
                    {checkout ? (
                        success ? (
                            <Box sx={{ textAlign: 'center', py: 4 }}>
                                <img src={successIcon} className="Success-icon" alt="success" />
                                <Typography variant="h5" sx={{ color: navy, fontFamily: 'Georgia, serif', mt: 2, mb: 1 }}>
                                    Thank You for Registering!
                                </Typography>
                                <Typography variant="body2" sx={{ color: '#555' }}>
                                    A confirmation email will be sent to <b>{eventData.parent.email}</b>
                                </Typography>
                            </Box>
                        ) : (
                            <Box>
                                <PaymentComp eventData={eventData} setSuccess={setSuccess} membershipData={membershipData} />
                                <Button variant="outlined" sx={{ mt: 3, borderColor: '#aaa', color: '#555' }} onClick={() => handleBack()}>
                                    Back
                                </Button>
                            </Box>
                        )
                    ) : (
                        <form onSubmit={checkoutHandler}>

                            <Section title="Event Details">
                                <Typography variant="body2" sx={{ mb: 0.5 }}><b>Event:</b> Balavihar Registration</Typography>
                                <Typography variant="body2" sx={{ mb: 0.5 }}><b>Period:</b> {memberships.balaviharPeriod}</Typography>
                                <Typography variant="body2">
                                    <b>Fees —</b> One Child: ${Math.round(tempData.membershipSingleChildFee)} &nbsp;|&nbsp;
                                    Two+ Children: ${Math.round(tempData.membershipTwoPlusChildFee)} &nbsp;|&nbsp;
                                    Parivar: ${Math.round(tempData.membershipParivarMemberFee)} &nbsp;|&nbsp;
                                    General (No BV): ${Math.round(tempData.membershipGeneralAdmissionFee)}
                                </Typography>
                            </Section>

                            <Section title="Membership Status">
                                {memberships.status === "ACTIVE" ? (
                                    <Box sx={{ bgcolor: '#e8f5e9', border: '1px solid #a5d6a7', borderRadius: 1, p: 2 }}>
                                        <Typography variant="body2">Status: <b>Active</b> — {memberships.balaviharPeriod}</Typography>
                                        <Typography variant="body2">Type: <b>{memberships.currentMembership.membershipTypesEntity.name}</b></Typography>
                                    </Box>
                                ) : (
                                    <Box sx={{ bgcolor: '#fff3e0', border: '1px solid #ffcc80', borderRadius: 1, p: 2 }}>
                                        <Typography variant="body2" sx={{ color: '#bf360c', fontWeight: 700, mb: 1.5 }}>
                                            Membership expired — RENEW for: <b>{memberships.balaviharPeriod}</b>
                                        </Typography>
                                        <FormControl variant="outlined" size="small" sx={{ minWidth: 240 }}>
                                            <InputLabel>Select membership type</InputLabel>
                                            <Select
                                                required
                                                name="membershipType"
                                                value={tempData.membershipType}
                                                onChange={e => setTempData({ ...tempData, [e.target.name]: e.target.value })}
                                                label="Select membership type"
                                            >
                                                <MenuItem value="Balavihar">Balavihar with Children</MenuItem>
                                                <MenuItem value="GeneralAdmission">General Member (NO Balavihar)</MenuItem>
                                            </Select>
                                        </FormControl>
                                    </Box>
                                )}
                            </Section>

                            {(tempData.membershipType === "Balavihar" || memberships.status === "ACTIVE") && (
                                <Section title="Balavihar Participants">
                                    {studentFields.length === 0 && (
                                        <FormGroup>
                                            <FormControlLabel
                                                control={<Switch />}
                                                label="Add Balavihar Children"
                                                onChange={peopleSwitchHandler}
                                            />
                                        </FormGroup>
                                    )}
                                    {studentFields.map((student, index) => (
                                        <Box key={index} sx={{ border: '1px solid #e0e0e0', borderRadius: 1, p: 2, mb: 2 }}>
                                            <Grid container spacing={2}>
                                                <Grid item xs={12} sm={6}>
                                                    <FormControl variant="outlined" fullWidth>
                                                        <InputLabel>Full Name</InputLabel>
                                                        <Select required name="fullName" value={student.fullName}
                                                            onChange={(e) => handleStudentChange(e, index)} label="Full Name">
                                                            {getAvailableChildren(index).map((item, i) => (
                                                                <MenuItem key={i} value={item}>{item}</MenuItem>
                                                            ))}
                                                        </Select>
                                                    </FormControl>
                                                </Grid>
                                                <Grid item xs={12} sm={6}>
                                                    <FormControl variant="outlined" fullWidth>
                                                        <InputLabel>Session</InputLabel>
                                                        <Select required name="session" value={student.session}
                                                            onChange={(e) => handleSessionChange(e, index)} label="Session">
                                                            {sessions && sessions.map((item, i) => (
                                                                <MenuItem key={i} value={item}>{item}</MenuItem>
                                                            ))}
                                                        </Select>
                                                    </FormControl>
                                                </Grid>
                                                <Grid item xs={12} sm={6}>
                                                    <FormControl variant="outlined" fullWidth>
                                                        <InputLabel>Grade</InputLabel>
                                                        <Select required name="grade" value={student.grade}
                                                            onChange={(e) => handleStudentChange(e, index)} label="Grade">
                                                            {grades.map((item, i) => (
                                                                <MenuItem key={i} value={item}>{item}</MenuItem>
                                                            ))}
                                                        </Select>
                                                    </FormControl>
                                                </Grid>
                                                <Grid item xs={12} sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                                    <Typography variant="body2" sx={{ color: '#555' }}>
                                                        {memberships.status === "ACTIVE" ? "Add additional participant:" : "Add / Remove participant:"}
                                                    </Typography>
                                                    {memberships.status !== "ACTIVE" && (
                                                        <IconButton size="small" onClick={() => handleRemoveFields(index)}>
                                                            <DeleteIcon />
                                                        </IconButton>
                                                    )}
                                                    <IconButton size="small" onClick={() => handleAddFields(index)}>
                                                        <PersonAddIcon />
                                                    </IconButton>
                                                </Grid>
                                            </Grid>
                                        </Box>
                                    ))}
                                    {error && <Alert severity="error" sx={{ mt: 1 }}>{error}</Alert>}
                                </Section>
                            )}

                            <Section title="Payment Summary">
                                <Grid container spacing={2}>
                                    <Grid item xs={12} sm={6}>
                                        <TextField fullWidth disabled label="Balavihar Fee Paid Amount ($)"
                                            type="number" variant="outlined" value={memberships.totalAmountPaid} />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <FormControlLabel
                                            control={
                                                <Checkbox checked={parivarEnabled} disabled={parivarMember}
                                                    onChange={parivarSwitchHandler}
                                                    sx={{ '&.Mui-checked': { color: amber } }} />
                                            }
                                            label={`$${tempData.membershipParivarMemberFee} — Upgrade to Parivar membership`}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        <TextField fullWidth label="Additional Donation ($)" type="number"
                                            name="donation" variant="outlined" value={donation} onChange={handleDonation} />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <FormControlLabel
                                            control={
                                                <Checkbox checked={feeEnabled} onChange={feeSwitchHandler}
                                                    sx={{ '&.Mui-checked': { color: amber } }} />
                                            }
                                            label="Add 3% to cover credit card processing fees"
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        <TextField fullWidth disabled label="Total Amount ($)" type="number"
                                            variant="outlined"
                                            inputProps={{ style: { fontSize: 22, fontWeight: 700, color: navy } }}
                                            InputLabelProps={{ style: { fontSize: 16 } }}
                                            value={totalAmount} />
                                    </Grid>
                                </Grid>
                            </Section>

                            <Section title="Waiver">
                                <Typography variant="body2" sx={{ mb: 1.5 }}>
                                    Please read the waiver before proceeding:{' '}
                                    <a href="https://membership.cmdfw.org/docs/cmdfw-waiver.pdf" target="_blank" rel="noopener noreferrer" style={{ color: amber }}>
                                        Open PDF
                                    </a>
                                </Typography>
                                <FormControlLabel
                                    control={
                                        <Checkbox checked={rulesAccepted} onChange={(e) => setRulesAccepted(e.target.checked)}
                                            sx={{ '&.Mui-checked': { color: amber } }} />
                                    }
                                    label="I have read and agree to the rules and policies"
                                />
                            </Section>

                            {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}

                            <Box sx={{ display: 'flex', gap: 2, mt: 1 }}>
                                <Button onClick={handleCancel} variant="outlined" sx={{ borderColor: '#bbb', color: '#555', px: 3 }}>
                                    Cancel
                                </Button>
                                <Tooltip title={!rulesAccepted ? "Please accept the rules and policies" : ""}>
                                    <span>
                                        <Button type="submit" variant="contained" disabled={!rulesAccepted}
                                            sx={{ bgcolor: amber, color: '#fff', fontWeight: 700, px: 4,
                                                '&:hover': { bgcolor: '#9a6f08' },
                                                '&.Mui-disabled': { bgcolor: '#e8d5a0', color: '#fff' } }}>
                                            Proceed to Checkout
                                        </Button>
                                    </span>
                                </Tooltip>
                            </Box>

                            <Typography variant="caption" sx={{ display: 'block', mt: 3, color: '#999' }}>
                                Questions? Contact us at{' '}
                                <a href="mailto:membership@cmdfw.org" style={{ color: amber }}>membership@cmdfw.org</a>
                            </Typography>

                        </form>
                    )}
                </Box>
            </Box>
        </Box>
    );
}